<template>
	<div class="chart rectangle-charts">
		<div class="title-analytics">
			<h1>{{ title }}</h1>
			<b-dropdown v-model="changeDays" aria-role="list" position="is-bottom-left">
				<button slot="trigger" slot-scope="{ active }" class="button">
					<span class="device-days">
						{{ `${(changeDays === 1) ? 'Últimas 24 horas' : 'Últimos ' + changeDays + ' dias'}` }}
					</span>
					<b-icon :icon="active ? 'menu-up' : 'menu-down'" />
				</button>
				<b-dropdown-item :value="1" aria-role="listitem">
					Últimas 24 horas
				</b-dropdown-item>
				<b-dropdown-item :value="7" aria-role="listitem">
					Últimos 7 dias
				</b-dropdown-item>
				<b-dropdown-item :value="30" aria-role="listitem">
					Últimos 30 dias
				</b-dropdown-item>
			</b-dropdown>
		</div>
		<div class="totals">
			<h4 class="chartSubtitle">
				{{ totals[0] }}
			</h4>
			<h3 class="chartTitle">
				Total
			</h3>
		</div>
		<apexcharts ref="chart" class="chart-apex" :options="chartOptions" :series="seriesData" color="#2323"
			type="area"
/>
	</div>
</template>

<script>
import apexcharts from 'vue-apexcharts';
import moment from 'moment';

export default {
	components: {
		apexcharts,
	},
	props: ['series', 'title', 'dateInterval', 'total', 'formated'],
	data() {
		return {
			changeDays: 1,
			seriesData: [
			],
			totals: '',
			color: '#018efa'
		};
	},
	computed: {
		filteredSeries() {
			return '';
		},
		chartOptions() {
			return {
				fill: {
					type: 'gradient',
					gradient: {
						shadeIntensity: 0.2,
						inverseColors: false,
						opacityFrom: 1,
						opacityTo: 0,
						stops: [0, 65, 100],
						colorStops: [
							{
								offset: 0,
								color: this.color,
								opacity: 0.4,
							},
							// {
							//   offset: 35,
							//   color: this.color,
							//   opacity: 0.3,
							// },
							{
								offset: 65,
								color: this.color,
								opacity: 0,
							},
							{
								offset: 100,
								color: this.color,
								opacity: 0,
							},
						],
					},
				},
				chart: {
					height: '140px',
					width: '100%',
					type: 'area',
					zoom: {
						enabled: false,
					},
					toolbar: {
						show: false,
					},
					lines: {
						show: false,
					},
				},
				dataLabels: {
					enabled: false,
				},
				stroke: {
					curve: 'smooth',
					width: 2.5
				},
				title: {
					text: '',
					align: 'center',
				},
				tooltip: {
					enabledOnSeries: false,
					shared: false,
					intersect: false,
					marker: {
						show: false,
					},
					x: {
						show: false,
					},
					y: {
						show: false,
						formatter: (value) => {
							let retorno = [];
							if (this.formated === 'time') {
								retorno = new Date(value * 1000).toISOString().slice(11, 19);
							} else if (this.formated === 'percent') {
								retorno = `${value}%`;
							} else {
								retorno = value;
							}
							return retorno;
						}
					},
					legend: {
						show: false,
					},
				},
				grid: {
					show: true,
					borderColor: '#FFF',
					strokeDashArray: 0,
					position: 'back',
					xaxis: {
						lines: {
							show: false,
						},
					},
					yaxis: {
						lines: {
							show: false,
						},
					},
					row: {
						colors: undefined,
						opacity: 0,
					},
					column: {
						colors: undefined,
						opacity: 0,
					},
					padding: {
						top: 0,
						right: 0,
						bottom: 0,
						left: 0,
					},
				},
				xaxis: {
					labels: {
						show: false,
					},
					categories: this.dateInterval[0],
					axisBorder: {
						show: false,
						color: '#fff',
						height: 5,
						width: '100%',
						offsetX: 0,
						offsetY: 0,
					},
				},
				yaxis: {
					labels: {
						show: false,
					},
				},
			};
		},
	},
	watch: {
		series() {
			this.mountChartData();
		},
		changeDays(value) {
			const startDate = moment().subtract(value, 'days').format('YYYY-MM-DD');
			this.$emit('change-date', startDate);
		},
	},
	methods: {
		mountChartData() {
			const [date_, totalStats, totals] = this.series;
			if (totals && !this.formated) {
				this.totals = totals;
			}

			if (this.formated) {
				this.totals = totals;
			}

			this.seriesData = [
				{
					name: this.title,
					data: totalStats
				}
			];

			this.chartOptions.xaxis = {
				categories: this.dateInterval[0],
			};
		},
	},
};
</script>

<style scoped>
.chart {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	max-width: 100%;
}

.title-analytics {
	display: flex;
	justify-content: space-between;
	padding: 20px;
	width: 100%;
}

.totals {
	flex-direction: row;
	justify-content: space-between;
	padding: 0 20px;
}

.chartTitle {
	font-size: 15px;
	color: rgb(70 70 70 / 70%);
	margin-bottom: -35px;
}

.chartSubtitle {
	margin-top: 20px;
	font-size: 23px;
	font-weight: bold;
	color: #424242;
}

.title-analytics h1 {
	font-size: 16px;
}

.button {
	all: unset;
	align-items: center;
	display: flex;
	padding-left: 5px;
	padding-right: 5px;
}

.device-days {
	font-size: 10px;
}

.chart-apex {
	display: flex;
	width: 103%;
	height: 100% !important;
	margin-left: -10px;
	margin-top: 13px;
	margin-bottom: -25px;
}

.analytics-block {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	box-sizing: border-box;
	flex-wrap: wrap;
	padding-bottom: 0;
}

.rectangle-charts {
	flex-direction: row;
	margin-top: 30px;
	border-radius: 5px;
	border: 1px solid #deebfd;
	box-shadow: -8px 12px 18px 0 #dadee8;
	max-height: 400px;
	background-color: #fff;
}
</style>
